// Готовые периоды фильтра по дате, в порядке списка в выборе периода.
export const PERIOD_PRESETS = [
  "today",
  "yesterday",
  "last_7_days",
  "last_14_days",
  "last_30_days",
  "this_month",
  "last_month",
] as const;

export type PeriodPreset = (typeof PERIOD_PRESETS)[number];
